import { createSelector } from 'reselect';
import { RootState } from '../reducers';

const selectAppState = (state: RootState) => state.app;

export const selectDataSources = createSelector([selectAppState], app => app.dataSources || []);
